// Wrapper around `size-sensor` to prevent unmount-time crashes.
// `echarts-for-react` calls `clear()` during `componentWillUnmount`.
// Some `size-sensor` edge-cases can throw (e.g. `disconnect` on undefined),
// and we don't want the whole React tree to log/throw.
//
// Import the real implementation via subpath so Vite `alias` (/^size-sensor$/) does not rewrite it.
import * as sizeSensorStar from "size-sensor/lib/index.js";

/** Aligns with `size-sensor` typings (Element & ElementCSSInlineStyle). */
type StyledElement = Element & ElementCSSInlineStyle;

type SizeSensorModule = {
  bind: <T extends StyledElement = HTMLElement>(
    element: T | null,
    cb: (element: T | null) => void
  ) => () => void;
  clear: (element: StyledElement | null) => void;
  ver?: string;
};

const sizeSensorMod = sizeSensorStar as unknown as SizeSensorModule;

export const bind = sizeSensorMod.bind;

export const clear = (element: StyledElement | null): void => {
  try {
    sizeSensorMod.clear(element);
  } catch {
    // swallow — safe cleanup failure shouldn't break the app
  }
};

export const ver = sizeSensorMod.ver;
